import { render, staticRenderFns } from "./ProductSupply.vue?vue&type=template&id=4568fcba&"
import script from "./ProductSupply.vue?vue&type=script&lang=js&"
export * from "./ProductSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports